import { ModuleWithProviders, NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';

import { AsyncJobsDialogModule } from './components/async-jobs-dialog/async-jobs-dialog.module';
import { AsyncJobsNotificationModule } from './components/async-jobs-notification/async-jobs-notification.module';
import { AsyncJobsProgressDisplayModule } from './components/async-jobs-progress-display/async-jobs-progress-display.module';
import { ASYNC_JOB_CONFIG_PROVIDER } from './configs/tokens';
import { AsyncJobEffects } from './store/async-job.effects';

@NgModule({
  imports: [
    AsyncJobsDialogModule,
    AsyncJobsNotificationModule,
    AsyncJobsProgressDisplayModule,
    EffectsModule.forFeature([AsyncJobEffects]),
  ],
})
export class AsyncJobModule {
  public static forRoot(): ModuleWithProviders<AsyncJobModule> {
    return {
      ngModule: AsyncJobModule,
      providers: [ASYNC_JOB_CONFIG_PROVIDER],
    };
  }
}
